import { SelectItem, FieldItem } from '../../types';

export interface SelectionValue {
  rollingAverage?: number;
  interval?: number;
  level?: SelectItem;
  category?: SelectItem;
  period?: SelectItem;
  type?: SelectionType;
  fillEmpty?: boolean;
  sortOrderType?: SelectItem;
}

export interface SelectionTypeItem {
  levels?: SelectItem[];
  categories?: SelectItem[];
  periods?: SelectItem[];
  type?: SelectionType;
  label?: string;
  defaultSelected?: boolean;
  showMissingValues?: boolean;
}

export interface SelectionFieldItem {
  selectionNo?: number;
  field: FieldItem;
  value?: SelectionValue;
  selectionTypes?: SelectionTypeItem[];
}

export enum SelectionType {
  NotSelected = 0,
  ActualValue = 1,
  Interval = 2,
  Period = 3,
  AggregateValue = 4,
  AggregateCategory = 5
}
